// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__nI3CL","info":"UpdateTermsInfo_info__15Euq"};